(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(44092);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/config/eipListConfig.js
const listEIP = [
    {
        eipName: "Personal Message",
        eipCode: "EIP-191",
        eipFunc: "personal_sign",
        available: true
    },
    {
        eipName: "Sign",
        eipCode: "EIP-712",
        eipFunc: "eth_sign",
        available: true
    },
    {
        eipName: "Sign Typed Data",
        eipCode: "EIP-712",
        eipFunc: "signTypedData_v4",
        available: true
    },
    {
        eipName: "Switch Network",
        eipCode: "EIP-3326",
        eipFunc: "wallet_switchEthereumChain",
        available: true
    },
    {
        eipName: "Add Matic Network",
        eipCode: "EIP-3085",
        eipFunc: "wallet_addEthereumChain",
        available: false
    },
    {
        eipName: "Send Transaction",
        eipCode: "EIP-155",
        eipFunc: "eth_sendTransaction",
        available: true
    },
    {
        eipName: "Sign Transaction",
        eipCode: "EIP-695",
        eipFunc: "eth_signTransaction",
        available: false
    },
    {
        eipName: "ETH Account",
        eipCode: "EIP-695",
        eipFunc: "eth_accounts",
        available: false
    },
    {
        eipName: "Net Version",
        eipCode: "EIP-695",
        eipFunc: "net_version",
        available: false
    },
    {
        eipName: "Chain Id",
        eipCode: "EIP-695",
        eipFunc: "eth_chainId",
        available: false
    },
    {
        eipName: "Uninstall Filter",
        eipCode: "EIP-695",
        eipFunc: "eth_uninstallFilter",
        available: false
    },
    {
        eipName: "Request Account",
        eipCode: "EIP-695",
        eipFunc: "eth_requestAccounts",
        available: true
    },
    {
        eipName: "EC Recover",
        eipCode: "EIP-695",
        eipFunc: "eth_ecRecover",
        available: false
    },
    {
        eipName: "Personal EC Recover",
        eipCode: "EIP-695",
        eipFunc: "personal_ecRecover",
        available: false
    },
    {
        eipName: "Send Raw Transaction",
        eipCode: "EIP-695",
        eipFunc: "eth_sendRawTransaction",
        available: false
    },
    {
        eipName: "Sign Typed Data V1",
        eipCode: "EIP-695",
        eipFunc: "eth_signTypedData_v1",
        available: false
    },
    {
        eipName: "Sign Typed Data V2",
        eipCode: "EIP-695",
        eipFunc: "eth_signTypedData_v2",
        available: false
    },
    {
        eipName: "Sign Typed Data V3",
        eipCode: "EIP-695",
        eipFunc: "eth_signTypedData_v3",
        available: false
    },
    {
        eipName: "Sign Typed Data",
        eipCode: "EIP-695",
        eipFunc: "eth_signTypedData",
        available: false
    },
    {
        eipName: "Watch Asset",
        eipCode: "EIP-695",
        eipFunc: "wallet_watchAsset",
        available: false
    },
    {
        eipName: "Subscribe",
        eipCode: "EIP-695",
        eipFunc: "eth_subscribe",
        available: false
    },
    {
        eipName: "Unsubscribe",
        eipCode: "EIP-695",
        eipFunc: "eth_unsubscribe",
        available: false
    },
    {
        eipName: "New Filter",
        eipCode: "EIP-695",
        eipFunc: "eth_newFilter",
        available: false
    },
    {
        eipName: "New Block Filter",
        eipCode: "EIP-695",
        eipFunc: "eth_newBlockFilter",
        available: false
    },
    {
        eipName: "New Pending Transaction Filter",
        eipCode: "EIP-695",
        eipFunc: "eth_newPendingTransactionFilter",
        available: false
    },
    {
        eipName: "Get Filter Changes",
        eipCode: "EIP-695",
        eipFunc: "eth_getFilterChanges",
        available: false
    },
    {
        eipName: "Get Filter Logs",
        eipCode: "EIP-695",
        eipFunc: "eth_getFilterLogs",
        available: false
    }
];

// EXTERNAL MODULE: ./node_modules/wagmi/dist/wagmi.esm.js + 26 modules
var wagmi_esm = __webpack_require__(67976);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/wagmi-core.esm.js + 1 modules
var wagmi_core_esm = __webpack_require__(84755);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
;// CONCATENATED MODULE: ./src/components/card/list.js









function EIPCard(param) {
    let {} = param;
    const { chain  } = (0,wagmi_core_esm/* getNetwork */.Hy)();
    const [chainId, setChainId] = (0,react.useState)(80001);
    const [changeChainId, setChangeChainId] = (0,react.useState)(chainId);
    const [render, setRender] = (0,react.useState)(false);
    const { connector  } = (0,wagmi_esm/* useConnect */.$4)();
    (0,react.useEffect)(()=>{
        setRender(true);
    }, []);
    const signMessage = (0,wagmi_esm/* useSignMessage */.QW)({
        message: "Welcome to wallet connect tester \uD83D\uDE0E",
        onError (error) {
            console.log("@error signMessage", error);
            if (error.reason) (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotify, {
                err: error.reason
            }));
            else (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotify, {
                err: error.message
            }));
        },
        onSuccess (data) {
            (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessNotify, {
                data: data
            }));
        }
    });
    const signType = (0,wagmi_esm/* useSignTypedData */.yw)({
        domain: {
            name: "Ether Mail",
            version: "1",
            chainId: 80001,
            verifyingContract: "0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC"
        },
        types: {
            Person: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "wallet",
                    type: "address"
                }
            ],
            Mail: [
                {
                    name: "from",
                    type: "Person"
                },
                {
                    name: "to",
                    type: "Person"
                },
                {
                    name: "contents",
                    type: "string"
                }
            ]
        },
        value: {
            from: {
                name: "Cow",
                wallet: "0xCD2a3d9F938E13CD947Ec05AbC7FE734Df8DD826"
            },
            to: {
                name: "Bob",
                wallet: "0xbBbBBBBbbBBBbbbBbbBbbbbBBbBbbbbBbBbbBBbB"
            },
            contents: "Hello, Bob!"
        },
        onError (error) {
            (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotify, {
                err: error.message
            }));
        },
        onSuccess (data) {
            (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessNotify, {
                data: data
            }));
        }
    });
    const send = (0,wagmi_esm/* useSendTransaction */.pQ)({
        mode: "recklesslyUnprepared",
        request: {
            to: "0x0A194EDb637c0C3007387a8Bf821C5C7C8274642",
            value: bignumber/* BigNumber.from */.O$.from("100000000000")
        },
        onError (error) {
            console.log("@error send transaction", error);
            if (error.reason) (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotify, {
                err: error.reason
            }));
            else (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotify, {
                err: error.message
            }));
        },
        onSuccess (data) {
            (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessNotify, {
                data: data
            }));
        }
    });
    const network = (0,wagmi_esm/* useSwitchNetwork */.g0)({
        throwForSwitchChainNotSupported: false,
        onError (error) {
            if (error.reason) (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotify, {
                err: error.reason
            }));
            else (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotify, {
                err: error.message
            }));
        },
        onSuccess (data) {
            (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessNotify, {
                data: data
            }));
        }
    });
    const getAcc = async ()=>{
        const provider = await (0,wagmi_core_esm/* getAccount */.D0)();
        console.log("@getAccount", provider);
    };
    const handlerRequest = (func)=>{
        switch(func){
            case "personal_sign":
                return signMessage.signMessage();
            case "eth_sign":
                return signMessage.signMessage();
            case "signTypedData_v4":
                return signType.signTypedData();
            case "wallet_switchEthereumChain":
                return network.switchNetwork(changeChainId);
            case "wallet_addEthereumChain":
                return network.switchNetwork();
            case "eth_sendTransaction":
                var ref;
                return (ref = send.sendTransaction) === null || ref === void 0 ? void 0 : ref.call(send);
            case "eth_requestAccounts":
                return getAcc();
            case "eth_signTransaction":
                return "ba";
        }
    };
    (0,react.useEffect)(()=>{
        chain && chain.id === 80001 ? setChangeChainId(137) : setChangeChainId(80001);
        chain && chain.id && setChainId(chain.id);
    }, [
        chain
    ]);
    return render && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-white shadow sm:rounded-lg mt-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 py-5 sm:p-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-lg font-medium leading-6 text-gray-900",
                        children: "List EIP"
                    }),
                    listEIP.map((item, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EIPList, {
                            eipName: item.eipName,
                            eipCode: item.eipCode,
                            eipHandler: item.eipFunc,
                            available: item.available,
                            handlerRequest: handlerRequest
                        }, i);
                    })
                ]
            })
        })
    });
}
function EIPList(param) {
    let { eipName , eipCode , eipHandler , handlerRequest , available  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "rounded-md bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sr-only",
                    children: "Visa"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sm:flex sm:items-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "h-8 w-auto sm:h-6 sm:flex-shrink-0",
                            viewBox: "0 0 36 24",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: 36,
                                    height: 24,
                                    fill: "#224DBA",
                                    rx: 4
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    d: "M10.925 15.673H8.874l-1.538-6c-.073-.276-.228-.52-.456-.635A6.575 6.575 0 005 8.403v-.231h3.304c.456 0 .798.347.855.75l.798 4.328 2.05-5.078h1.994l-3.076 7.5zm4.216 0h-1.937L14.8 8.172h1.937l-1.595 7.5zm4.101-5.422c.057-.404.399-.635.798-.635a3.54 3.54 0 011.88.346l.342-1.615A4.808 4.808 0 0020.496 8c-1.88 0-3.248 1.039-3.248 2.481 0 1.097.969 1.673 1.653 2.02.74.346 1.025.577.968.923 0 .519-.57.75-1.139.75a4.795 4.795 0 01-1.994-.462l-.342 1.616a5.48 5.48 0 002.108.404c2.108.057 3.418-.981 3.418-2.539 0-1.962-2.678-2.077-2.678-2.942zm9.457 5.422L27.16 8.172h-1.652a.858.858 0 00-.798.577l-2.848 6.924h1.994l.398-1.096h2.45l.228 1.096h1.766zm-2.905-5.482l.57 2.827h-1.596l1.026-2.827z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-3 sm:mt-0 sm:ml-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm font-medium text-gray-900",
                                    children: eipName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-1 text-sm text-gray-600 sm:flex sm:items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: eipCode
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "hidden sm:mx-2 sm:inline",
                                            "aria-hidden": "true",
                                            children: "\xb7"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-4 sm:mt-0 sm:ml-6 sm:flex-shrink-0",
                    children: available ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            handlerRequest(eipHandler);
                        },
                        className: "inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                        children: "Execute"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "inline-flex items-center rounded-md border border-transparent bg-indigo-100 px-3 py-2 text-sm font-medium leading-4 text-indigo-700 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                        children: "Not Available"
                    })
                })
            ]
        })
    });
}
const SuccessNotify = (param)=>{
    let { data  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "font-bold underline",
        children: "Request Approved!"
    });
};
const ErrorNotify = (param)=>{
    let { err  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "font-bold underline bg-danger",
        children: err
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/config/index.js + 37 modules
var config = __webpack_require__(43637);
// EXTERNAL MODULE: ./src/components/button/connect.js + 36 modules
var connect = __webpack_require__(56357);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/providers/public/dist/wagmi-core-providers-public.esm.js
var wagmi_core_providers_public_esm = __webpack_require__(54048);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chains-8fce19d8.esm.js + 1 modules
var chains_8fce19d8_esm = __webpack_require__(81226);
;// CONCATENATED MODULE: ./src/pages/index.js











function Index() {
    const router = (0,next_router.useRouter)();
    const { connect  } = (0,wagmi_esm/* useConnect */.$4)();
    const { chains  } = (0,wagmi_core_esm/* configureChains */.QB)([
        chains_8fce19d8_esm.t,
        chains_8fce19d8_esm.u
    ], [
        (0,wagmi_core_providers_public_esm/* publicProvider */.I)()
    ]);
    const { selectedAddress , verifier , loggedIn , rehydrate , state  } = router.query;
    const { isConnected  } = (0,wagmi_esm/* useAccount */.mA)();
    const [connected, setConnected] = (0,react.useState)(false);
    const [loginData, setLoginData] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        const selectedAddressLocal = localStorage.getItem("autoLogin");
        if (selectedAddress) {
            const autoLoginData = JSON.stringify({
                selectedAddress,
                verifier,
                loggedIn,
                rehydrate,
                state
            });
            localStorage.setItem("autoLogin", autoLoginData);
            const upbondLogin = new config/* UpbondConnector */.yX({
                chains,
                options: {
                    buildEnv: "development",
                    enableLogging: true,
                    buttonPosition: "bottom-left",
                    showTorusButton: true
                }
            });
            connect({
                connector: upbondLogin
            });
        }
        if (!selectedAddress && selectedAddressLocal) {
            const autoLoginData1 = JSON.parse(selectedAddressLocal);
            if (!selectedAddress && autoLoginData1) {
                if (autoLoginData1.selectedAddress && autoLoginData1.selectedAddress != "undefined") {
                    router.push({
                        pathname: "/",
                        query: {
                            selectedAddress: autoLoginData1.selectedAddress,
                            verifier: autoLoginData1.verifier,
                            loggedIn: autoLoginData1.loggedIn,
                            rehydrate: autoLoginData1.rehydrate,
                            state: autoLoginData1.state
                        }
                    });
                    console.log("@kog bisa kesini", selectedAddress);
                // window.location.href = `?selectedAddress=${autoLoginData.selectedAddress}&verifier=${autoLoginData.verifier}&loggedIn=${autoLoginData.loggedIn}&rehydrate=${autoLoginData.rehydrate}&state=${autoLoginData.state}`;
                }
            }
        }
    }, [
        selectedAddress
    ]);
    (0,react.useEffect)(()=>{
        isConnected && setConnected(true);
    }, [
        isConnected
    ]);
    return connected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EIPCard, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "aria-hidden": "true",
                    className: "absolute"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto flex max-w-3xl flex-col items-center py-32 px-6 text-center sm:py-64 lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-4xl font-bold tracking-tight text-black lg:text-6xl",
                            children: "Wallet Connect Tester (Deprecated)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-4 text-xl text-black",
                            children: "Please connect wallet first to use overpower tester"
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80880)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);